export const activationTranslations = {
  en: {
    timePill: 'Takes about a minute',
    pageTitle: 'Activate Finley on your phone.',
    pageSubtitle: 'Create your personal activation code, download the app, and continue setup there.',
    emailPlaceholder: 'you@example.com',
    invalidEmail: 'Please enter a valid email address.',
    requestError: 'Something went wrong creating your code. Please try again.',
    createCode: 'Create my activation code',
    creatingCode: 'Creating your code',
    codeCreated: 'Activation code created',
    createAnother: 'Create another code',
    generatingTitle: 'Generating your code',
    generatingSubtitle: 'Securing your spot…',
    codeReady: 'Your code is ready',
    sentTo: 'Sent to',
    copied: 'Copied',
    copyCodeLabel: 'Copy activation code',
    scanTitle: 'Scan to download Finley',
    downloadTitle: 'Download the app',
    activationCodeLabel: 'Your activation code',
    idlePrompt: 'Enter your email to reveal your code.',
    modalTitle: 'Your money has a next move.',
    modalDescription: 'Enter your email and we’ll create your personal activation code. It keeps your account setup connected from web to app.',
    closeModalLabel: 'Close activation modal',
    closeLabel: 'Close',
    appStoreAlt: 'Download on the App Store',
    playStoreAlt: 'Get it on Google Play',
  },
  de: {
    timePill: 'Dauert etwa eine Minute',
    pageTitle: 'Du & Finley.',
    pageSubtitle: 'Erstelle deinen Code, lade die App und leg los.',
    emailPlaceholder: 'du@beispiel.de',
    invalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    requestError: 'Beim Erstellen deines Codes ist etwas schiefgegangen. Bitte versuche es erneut.',
    createCode: 'Meinen Code erstellen',
    creatingCode: 'Code wird erstellt',
    codeCreated: 'Aktivierungscode erstellt',
    createAnother: 'Anderen Code erstellen',
    generatingTitle: 'Dein Code wird erstellt',
    generatingSubtitle: 'Wir sichern deinen Platz…',
    codeReady: 'Dein Code ist bereit',
    sentTo: 'Gesendet an',
    copied: 'Kopiert',
    copyCodeLabel: 'Aktivierungscode kopieren',
    scanTitle: 'Finley herunterladen',
    downloadTitle: 'App herunterladen',
    activationCodeLabel: 'Dein Aktivierungscode',
    idlePrompt: 'Gib deine E-Mail-Adresse ein, um deinen Code zu erhalten.',
    modalTitle: 'Dein Geld hat einen nächsten Schritt.',
    modalDescription: 'Gib deine E-Mail-Adresse ein und wir erstellen deinen persönlichen Aktivierungscode. So bleibt deine Einrichtung vom Web bis zur App verbunden.',
    closeModalLabel: 'Aktivierungsmodal schließen',
    closeLabel: 'Schließen',
    appStoreAlt: 'Im App Store laden',
    playStoreAlt: 'Bei Google Play herunterladen',
  },
} as const

export type ActivationLocale = keyof typeof activationTranslations
